import { Organization } from "@packages/client";

import { apiProxyRequest } from "Api/apiProxyRequest";

type UpdateOrganizationPayload = Partial<{
  billing_profile_id: string;
}>;

export const updateOrganizationRequest = (
  organizationId: string,
  updates: UpdateOrganizationPayload
) =>
  apiProxyRequest<Organization>(
    `/organizations/${organizationId}`,
    "PATCH",
    updates
  );
